function HomeFormatConverterTransformer(Util, jsonMapper) {

	function convertDateAndTimeTheGuidewireWay(dateTime) {
		var format = "{0} at {1} AEST" ;
		return Util.stringFormat(format, dateTime.format('Do MMM YYYY') , dateTime.format('h:mma')) ;
	}

	function convertDate(dateString) {
		var date = moment(dateString, 'DD/MM/YYYY') ;
		var formattedDate = date.format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		// throw 'date format exception formatting ' + dateString ;
		return null;
	}

	function convertDateToGWTimeZone(dateString) {
		var formattedDate = moment(dateString,'DDMMYYYY').tz("Australia/Sydney").format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		return null;
	}
	 
	function getMonthString(monthInFigure){
		if(monthInFigure){
			var objDate = new Date("2000-"+String(monthInFigure)+"-01");
	    	return objDate.toLocaleString("en-au", { month: "long" });
		}
		return null;
	}


	function getMonthNumber(monthInString){
		if(monthInString){
			var monthObj = {
				'January': '01',
				'February': '02',
				'March': '03',
				'April': '04',
				'May': '05',
				'June': '06',
				'July': '07',
				'August': '08',
				'September': '09',
				'October': '10',
				'November': '11',
				'December': '12',
			}

			return monthObj[monthInString];
		}
		return null;
	}

	function convertGender(gender) {
		var gc = {
			male : 'M',
			female : 'F',
			intersex : 'I',
		};

		return gc[gender] ;
	}

	function convertFalsyToUnknown(value) {

		if ( value === null || value === undefined)
			return 'unknown';

		if(value === 'unknown')
			return 'unknown';

		return convertBooleanToYesNo(value) ;
	}

	function convertBooleanToYesNo(value) {
		return !!value ? 'yes' : 'no' ;
	}

	function convertStringToInt(value) {
		return parseInt(value);
	}

	function convertIntToString(value) {
		return value.toString();
	}

	function convertHomelevels(value){
		if(value=='3+'){
			value = '3Plus';
		}
		return value;
	}

	function convertNumberToStringPattern(value, pattern, zeroValue) {
		var stringValue = value > 0 ? Util.stringFormat(pattern, value) : zeroValue ;
		return ( value == 0 || value > 1) ? stringValue + 's' : stringValue ;
	}

	function convertNumberToStringPatternZeroSingular(value, pattern, zeroValue) {
		var stringValue = value > 0 ? Util.stringFormat(pattern, value) : zeroValue ;
		return (value > 1) ? stringValue + 's' : stringValue ;
	}

	var convertValueMapping = {
		'dwellings.*.isUnitAboveGround' : convertBooleanToYesNo,
		'dwellings.*.isPortionAboveGround' : convertBooleanToYesNo,
		'dwellings.*.isCycloneStandardlyBuilt' : convertBooleanToYesNo,
		'isInsuredsRetired': convertBooleanToYesNo,

		"dwellings.*.homeLevels": convertHomelevels,
		"dwellings.*.locationSecurity.hasDoorDeadlocks" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasDoorSecurityScreen" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasWindowKeylocks" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasWindowRollerShutter" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasWindowScreenBars" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.isGatedCommunity" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.hasFixedHomeSafe" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.isSecurityRatedBuilding" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.haveSecurityAlarm" : convertBooleanToYesNo,
		"dwellings.*.locationSecurity.has24HourConcierge" : convertBooleanToYesNo,


		"policyHolders.*.contact.dateOfBirth" : convertDate,
		"policyHolders.*.contact.dwellingHistory.*.eventMonth":getMonthNumber,
		"policyHolders.*.contact.gender":convertGender,

		"policyHolders.*.contact.authorisedPersons.*.person.gender":convertGender,
		"policyHolders.*.contact.authorisedPersons.*.person.dateOfBirth":convertDate,



		/**
		* Guide Wire formatting for bedrooms, balconies and etc ...
		* bring popcorn

		for none of each :

		numberOfBalconies:"no_balconies_or_decks"
		numberOfBedrooms:"1_item"
		numberOfCarports:"no_carports"
		numberOfGarages:"no_garages"
		numberOfVerandahs:"no_verandahs"

		For 1 of each :

		numberOfBalconies:"1_item"
		numberOfBedrooms:"1_item"
		numberOfCarports:"carport_for_1_car"
		numberOfGarages:"garage_for_1_car"
		numberOfVerandahs:"1_item"

		For 2 of each :

		numberOfBalconies:"2_items"
		numberOfBedrooms:"2_items"
		numberOfCarports:"carport_for_2_cars"
		numberOfGarages:"garage_for_2_cars"
		numberOfVerandahs:"2_items"

		for max of each :

		numberOfBalconies:"6_items"
		numberOfBedrooms:"9_items"
		numberOfCarports:"carport_for_6_cars"
		numberOfGarages:"garage_for_6_cars"
		numberOfVerandahs:"6_items"
		*/
		"dwellings.0.locationProperty.numberOfBedrooms" : function(value) {return convertNumberToStringPattern(value, '{0}_item', '1_item')},
		"dwellings.0.locationProperty.numberOfBalconies" : function(value) {return convertNumberToStringPattern(value, '{0}_item', 'no_balconies_or_deck')},
		"dwellings.0.locationProperty.numberOfVerandahs" : function(value) {return convertNumberToStringPattern(value, '{0}_item', 'no_verandah')},
		"dwellings.0.locationProperty.numberOfCarports" :  function(value) {return convertNumberToStringPattern(value, 'carport_for_{0}_car', 'no_carport')},
		"dwellings.0.locationProperty.numberOfGarages" : function(value) {return convertNumberToStringPattern(value, 'garage_for_{0}_car', 'no_garage')},
		"dwellings.0.locationProperty.numberOfLargeSheds" : function(value) {return convertNumberToStringPatternZeroSingular(value, '{0}_item', '0_item')},
		"dwellings.0.locationProperty.numberOfSmallSheds" : function(value) {return convertNumberToStringPatternZeroSingular(value,  '{0}_item', '0_item')},
		"periodStartDate": convertDateToGWTimeZone,

	};

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.convert(intermediateRequest, convertValueMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}
